/* eslint-disable import/namespace */
import * as Sentry from '@sentry/nextjs'

import { upsertNewCartClient } from '@/lib/data/cart-queries'
import {
  LasooCartAction,
  type LasooCartInput,
} from '@/lib/generated/platform-graphql'
import { type UserCart } from '../cart-types'

const updateCouponForUserCart = async (
  cartInput: LasooCartInput,
  abortSignal?: AbortSignal,
): Promise<{ cart?: UserCart; success: boolean }> => {
  try {
    const cart = await upsertNewCartClient(
      cartInput,
      LasooCartAction.AddCoupon,
      abortSignal,
    )
    if (cart !== false && cart?.__typename === 'LasooCart') {
      return { cart, success: true }
    }
    Sentry.captureException(new Error('Error upserting user cart'))
  } catch (error) {
    Sentry.captureException(error)
    throw error
  }
  return { cart: undefined, success: false }
}

export const updateCartCoupon = async (
  setCart: (newCart?: UserCart) => void,
  cartInput: LasooCartInput,
  abortSignal?: AbortSignal,
) => {
  const userCartResult = await updateCouponForUserCart(cartInput, abortSignal)

  if (userCartResult?.cart?.__typename === 'LasooCart') {
    setCart(userCartResult.cart)
  }

  return userCartResult?.success
}
